import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { liveAudioRecorder } from '../services/liveAudioRecorderStore';

/**
 * After login / refresh, resume any in-progress live audio recording
 * so the user does not need to press Record again.
 */
export default function LiveAudioRecorderBootstrap() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return undefined;
    let cancelled = false;
    (async () => {
      try {
        if (!cancelled) await liveAudioRecorder.bootstrapFromStorage(user.id);
      } catch {
        /* best-effort */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  return null;
}
